/* DESIGNSPOT – popup newsletter (10/2026) */
(function () {
  var el = document.getElementById('DsNlPop');
  if (!el) return;
  var KEY = 'dsNlPop', PV = 'dsNlPopPv', DAY = 864e5;
  var bar = el.querySelector('.dsn__bar'), box = el.querySelector('.dsn__box');
  var form = el.querySelector('form'), input = el.querySelector('input[type=email]');
  var err = el.querySelector('.dsn__err'), ok = el.querySelector('.dsn__ok'), inner = el.querySelector('.dsn__in');
  var pause = parseInt(el.dataset.pause, 10) || 30, delay = (parseInt(el.dataset.delay, 10) || 10) * 1000;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.2,.8,.2,1)';
  var timer;

  function get(s, k) { try { return s.getItem(k); } catch (e) { return null; } }
  function set(s, k, v) { try { s.setItem(k, v); } catch (e) {} }
  function track(a) { try { (window.dataLayer = window.dataLayer || []).push({ event: 'ds_nl_popup', ds_nl_action: a }); } catch (e) {} }
  function mobile() { return window.matchMedia('(max-width:749px)').matches; }

  /* návrat po ověření (captcha) po nativním odeslání */
  var returned = /customer_posted=true/.test(location.search) && !!get(sessionStorage, KEY + 'Sent');
  if (returned) {
    try { sessionStorage.removeItem(KEY + 'Sent'); } catch (e) {}
    set(localStorage, KEY, JSON.stringify({ s: 'yes', t: Date.now() }));
  }

  var st = null;
  try { st = JSON.parse(get(localStorage, KEY) || 'null'); } catch (e) {}
  var subscribed = !!(st && st.s === 'yes');
  var paused = !!(st && st.s === 'no' && Date.now() - st.t < pause * DAY);

  /* odkazy na /pages/newsletter (např. stránka Clubu) otevřou rovnou formulář – i když je automatické zobrazení pozastavené */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
    if (u.host !== location.host || !/^\/(sk\/)?pages\/newsletter\/?$/.test(u.pathname)) return;
    e.preventDefault();
    e.stopPropagation(); /* šablona má vlastní přechod mezi stránkami navázaný na odkazy */
    openDirect();
  }, true);


  var pv = (parseInt(get(sessionStorage, PV), 10) || 0) + 1;
  set(sessionStorage, PV, pv);

  function consentPending() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!(cp && cp.shouldShowBanner && cp.shouldShowBanner() && !cp.currentVisitorConsent().marketing && !cp.currentVisitorConsent().analytics); } catch (e) { return false; }
  }
  function busy() {
    var h = document.documentElement;
    return consentPending() || h.classList.contains('dsh-locked') || h.classList.contains('dsh-search-open') || document.body.classList.contains('ds-sheet-lock');
  }

  function show() {
    if (!el.hidden) return;
    if (busy()) { setTimeout(show, 2000); return; }
    el.hidden = false;
    track('show');
    if (!reduce && el.animate) el.animate([{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }], { duration: 400, easing: EASE });
  }

  function hide(after) {
    var done = function () { el.hidden = true; if (after) after(); };
    if (reduce || !el.animate) return done();
    el.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(16px)' }], { duration: 250, easing: EASE }).onfinish = done;
  }

  function dismiss() {
    set(localStorage, KEY, JSON.stringify({ s: 'no', t: Date.now() }));
    track(el.classList.contains('is-open') ? 'close' : 'no');
    hide();
  }

  function open() {
    track('yes');
    var r0 = el.getBoundingClientRect();
    var w0 = r0.width;
    bar.hidden = true; bar.style.display = 'none';
    box.hidden = false;
    if (!mobile()) box.style.width = Math.max(w0, 400) + 'px';
    el.classList.add('is-open');
    var r1 = el.getBoundingClientRect();
    if (!reduce && el.animate) {
      el.animate([
        { width: w0 + 'px', height: r0.height + 'px', backgroundColor: '#FFDE59' },
        { width: r1.width + 'px', height: r1.height + 'px', backgroundColor: '#FFEEAC' }
      ], { duration: 550, easing: EASE });
      box.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 0, transform: 'translateY(8px)', offset: 0.4 }, { opacity: 1, transform: 'none' }], { duration: 550, easing: EASE });
    }
    setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 560);
  }

  function openDirect() {
    clearTimeout(timer);
    if (!el.hidden && el.classList.contains('is-open')) { try { input.focus(); } catch (e) {} return; }
    track('link');
    bar.hidden = true; bar.style.display = 'none';
    box.hidden = false;
    if (!mobile()) box.style.width = '400px';
    el.classList.add('is-open');
    el.hidden = false;
    if (!reduce && el.animate) el.animate([{ opacity: 0, transform: 'translateY(16px)' }, { opacity: 1, transform: 'none' }], { duration: 400, easing: EASE });
    setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 420);
  }

  function success() {
    set(localStorage, KEY, JSON.stringify({ s: 'yes', t: Date.now() }));
    track('subscribe');
    inner.hidden = true; inner.style.display = 'none';
    ok.hidden = false;
    setTimeout(function () { hide(); }, 4000);
  }

  function fail() {
    err.textContent = el.dataset.err || '';
    err.hidden = false;
  }

  el.addEventListener('click', function (e) {
    if (e.target.closest('[data-dsn-yes]')) { e.preventDefault(); open(); }
    else if (e.target.closest('[data-dsn-no]')) { e.preventDefault(); dismiss(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !el.hidden) dismiss(); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    err.hidden = true;
    var v = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { fail(); input.focus(); return; }
    var btn = form.querySelector('button[type=submit]');
    btn.disabled = true;
    /* klasické odeslání jako záloha: Shopify může chtít ověření (captcha); po návratu se ukáže poděkování */
    function native() { set(sessionStorage, KEY + 'Sent', '1'); track('submit'); form.submit(); }
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) {
        if (r.ok && /customer_posted=true/.test(r.url)) { btn.disabled = false; return success(); }
        native();
      })
      .catch(native);
  });

  /* po návratu z klasického odeslání: krátké poděkování */
  if (returned) {
    bar.hidden = true; bar.style.display = 'none';
    box.hidden = false;
    if (!mobile()) box.style.width = '400px';
    el.classList.add('is-open');
    inner.hidden = true; inner.style.display = 'none';
    ok.hidden = false;
    el.hidden = false;
    track('subscribe');
    setTimeout(function () { hide(); }, 5000);
    return;
  }

  /* přesměrování ze staré stránky /pages/newsletter → /pages/club#newsletter otevře rovnou formulář */
  if (location.hash === '#newsletter') { setTimeout(openDirect, 600); return; }

  if (subscribed || paused) return;
  timer = setTimeout(show, pv >= 2 ? 1500 : delay);
})();
